import { HttpErrorResponse } from "@angular/common/http";
import { Component, ElementRef, Inject, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { BookingService } from "../services/jrni/booking.service";
import { AlertService } from "../_alert";
import { AvailabilityService } from "../services/jrni/availability.service";
import * as moment from "moment";
import { ApiService } from "../services/jrni/api.service";
import { interval } from "rxjs";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { DepartmentService } from "../services/jrni/department.service";
import { FormBuilderService } from "../services/form-builder.service";
import { AppConfig } from "../app.config";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EmailService } from "../services/email.service";
import { MemberService } from "../services/jrni/member.service";

interface DialogData {
  booking;
  location;
  action;
  service;
  member;
  header;
}

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
})
export class ModalComponent implements OnInit {
  cancelMessage = false;
  cancelPromptMessage = true;
  cancelPassed: boolean;
  modifyPassed: boolean;
  slotEmpty = false;
  selectedSlot: Date;
  selectedSlotPersonId: any;
  subscription: any;
  bookingQuestions: any;
  vehicleStatus: number;
  maxChildren: number = 3;
  myVehicles: any = [];
  myAddresses: any = [];
  addresses: any = [];
  postcodeValidator =
    "^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))s?[0-9][A-Za-z]{2}))$";
  address_id: any;
  postcode_id: any;
  idLocalAddress: boolean = true;
  public dvlaLookupQuestionMap = AppConfig.settings.dvlaLookupQuestionMap;
  loading: boolean = true;
  showQuestions: boolean = false;
  submitted: boolean;
  validationError: boolean;
  subscription2: any;
  manualText: boolean = false;
  showingAddresses: boolean = true;
  selectedAddressId: number;
  bookingQuestionsForm: FormGroup;
  questionsLoaded: boolean = false;
  motStatusInvalid: boolean = false;
  taxStatusInvalid: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private bookingService: BookingService,
    private apiService: ApiService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private departmentService: DepartmentService,
    public formService: FormBuilderService,
    public memberService: MemberService,
    private formBuilder: FormBuilder,
    private emailService: EmailService,
    private spinner: NgxSpinnerService,
    private ElByClassName: ElementRef,
    private availabilityService: AvailabilityService
  ) {
    this.bookingQuestionsForm = this.formBuilder.group({});

  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  get bookingForm() {
    return this.bookingQuestionsForm.controls;
  }

  ngOnInit() {
    this.initialiseBookingView();
  }

  ngAfterViewInit() {
    const inter = interval(500); // repetedly check to see if we need to add avaiable/unavaiable to the aria (which is sued by screen readers)
    this.subscription2 = inter.subscribe((val) => {
      if (document.getElementsByClassName("mat-dialog-container")[0])
        document
          .getElementsByClassName("mat-dialog-container")[0]
          .removeAttribute("role");
      if (document.getElementsByClassName("mat-dialog-container")[0])
        document
          .getElementsByClassName("mat-dialog-container")[0]
          .removeAttribute("aria-modal");
    });
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription2) this.subscription2.unsubscribe();
  }

  async initialiseBookingView() {
    window.scroll(0, 0);

    // if (this.data['booking'].canCancel()) {
    this.cancelPassed = false;
    this.modifyPassed = false;
    this.showQuestions = false;
    this.myAddresses = [];
    this.myVehicles = [];
    // } else {
    //   this.cancelMessage = false;
    //   this.cancelPassed = true;
    //   this.modifyPassed = true;
    // }
    if (this.data.booking.time === undefined) {
      this.data.booking.time = moment(this.data.booking.datetime).format(
        "HH:mm"
      );
      this.data.booking.endTime = moment(this.data.booking.datetime)
        .add(this.data.booking.duration, "second")
        .format("HH:mm");
    }
    console.log(this.data.booking.questions);
    console.log("Object.keys(this.data.booking.questions)", Object.keys(this.data.booking.questions))
    let address = null;
    let postcode = null;
    let registration = null;
    let rest = [];
    let answers = this.data.booking.answers
    if (!answers) {
      answers = await this.data.booking.getAnswers()
    }
    console.log("answers", answers)
    for (let answer of answers) {
      console.log("answer", answer)

      if (answer.question_text.includes("address")) {
        address = answer;
      } else if (
        answer.question_text.includes("postcode")
      ) {
        postcode = answer;
      } else if (
        answer.question_text.includes("registration")
      ) {
        registration = answer;
      } else {
        rest.push(answer);
      }
    }
    console.log("answers", answers)

    let sorted = [];
    if (address) {
      sorted.push(address);
    }
    if (postcode) {
      sorted.push(postcode);
    }
    if (registration) {
      sorted.push(registration);
    }
    console.log(address, postcode, registration);
    for (let question of rest) {
      sorted.push(question);
    }
    console.log(sorted);
    this.data.booking.questions = sorted;
    this.questionsLoaded = true
    if (this.data.action === "modify") {
      const source = interval(500); // repetedly check to see if we need to add available/unavailable to the aria (which is used by screen readers)
      this.subscription = source.subscribe((val) => {
        // this.spinner.show();
      });
    }

    console.log(this.data.service);
    if (this.data.action !== "details") {
      this.spinner.hide();
    } else {
      this.departmentService.getParentDepartment().then((parentCompany) => {
        this.apiService
          .questions(this.data.service.detail_group_id, parentCompany.id)
          .then(async (res: any) => {
            const pId = parentCompany.id;
            const pClient = parentCompany.self.split('://')[1].split('.')[0];
            const config: any = await this.apiService.getConfig(pClient, pId);
            // this.postcode_id = AppConfig.settings.booking_address;
            // this.address_id = AppConfig.settings.booking_address;
            // const addressQuestions = [
            //   {
            //     detail_type: "postcode",
            //     id: this.postcode_id,
            //     name: "Booking postcode",
            //     required: true,
            //     visible: true,
            //     settings: {},
            //   },
            //   {
            //     detail_type: "address",
            //     id: this.address_id,
            //     name: "Booking address",
            //     required: true,
            //     visible: true,
            //     settings: {},
            //   },
            // ];
            // this.bookingQuestions = addressQuestions.concat(res.questions);
            this.bookingQuestions = res.questions;
            // this.datastoreService.bookingQuestions = this.bookingQuestions;
            console.log(this.bookingQuestions);

            // this.bookingQuestionsForm.addControl(
            //   this.postcode_id,
            //   new FormControl("", [
            //     Validators.required,
            //     Validators.pattern(this.postcodeValidator),
            //   ])
            // );
            // this.bookingQuestionsForm.addControl(
            //   this.address_id,
            //   new FormControl("", Validators.required)
            // );
            for (let index = 0; index < this.bookingQuestions.length; index++) {
              const question = this.bookingQuestions[index];
              question.visible = false;
              question.reference = question.id;
              if (!question.admin_only) {
                if (!question.settings) {
                  question.visible = true;
                } else if (
                  !question.settings.hasOwnProperty("conditional_question")
                ) {
                  question.visible = true;
                }
                const questionControl = question.id;

                if (
                  question.detail_type == "check" ||
                  question.detail_type == "check-price"
                ) {
                  if (question.required) {
                    this.bookingQuestionsForm.addControl(
                      questionControl,
                      new FormControl(false, Validators.requiredTrue)
                    );
                  } else {
                    this.bookingQuestionsForm.addControl(
                      questionControl,
                      new FormControl(false)
                    );
                  }
                } else {
                  if (question.required) {
                    this.bookingQuestionsForm.addControl(
                      questionControl,
                      new FormControl("", Validators.required)
                    );
                  } else {
                    this.bookingQuestionsForm.addControl(
                      questionControl,
                      new FormControl("")
                    );
                  }
                }
              }
            }
            if (this.data.member) {
              console.log(this.data.member);
              for (let i = 1; i <= this.maxChildren; i++) {
                const address: any = await this.apiService.getHwrcAddressForm(
                  this.data.member.id,
                  parentCompany.id,
                  i
                );
                if (address.hasOwnProperty("Item")) {
                  this.myAddresses.push(address.Item);
                }
                const vehicle: any = await this.apiService.getHwrcVehicleForm(
                  this.data.member.id,
                  parentCompany.id,
                  i
                );
                if (vehicle.hasOwnProperty("Item")) {
                  this.myVehicles.push(vehicle.Item);
                }
              }
            }
            // Repopulate the booking questions when coming back
            this.repopulateQuestions();
          });
      });
    }
  }

  async getPostcode() {
    // for when selecting from a client's prefilled list of addresses
    let address: String = this.bookingQuestionsForm.value[this.address_id];
    const selectedAddress = this.myAddresses.find((x) => x.address === address);
    // populate the postcode question
    if (selectedAddress) {
      this.bookingQuestionsForm.controls[this.postcode_id].setValue(
        selectedAddress.postcode
      );
      this.bookingQuestionsForm.controls[this.postcode_id].patchValue(
        selectedAddress.postcode
      );
    } else {
      // won't be using the dropdown list as booking was made as a guest
      this.manualText = true;
      this.myVehicles = [];
      this.myAddresses = [];
      await this.getAddress(true);
    }

    // check if it is local
    const res: any = await this.apiService.get(
      this.bookingQuestionsForm.value[this.postcode_id]
    );
    const foundAddress = res.results.find((x) => {
      if (x.DPA) {
        return x.DPA.ADDRESS === address;
      } else if (x.LPI) {
        return x.LPI.ADDRESS === address;
      } else {
        return false;
      }
    });
    if (foundAddress) {
      this.idLocalAddress = this.formService.localAddress(foundAddress);
    } else {
      console.log("error: could not find address address in ", res);
      this.idLocalAddress = false;
    }
  }


  // "No details held by DVLA" / "No results returned" mean the vehicle is too new to need an MOT, so it passes
  isMotStatusInvalid(motStatus: string): boolean {
    return motStatus !== "Valid" && motStatus !== "No details held by DVLA" && motStatus !== "No results returned";
  }

  async getVehicle() {
    this.spinner.show();
    let vehiclereg: String =
      this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId];
    this.motStatusInvalid = false;
    this.taxStatusInvalid = false;
    this.vehicleStatus = 0;
    try {
      const vehicleLookup: any = await this.apiService.getVehicleDetails(
        vehiclereg
      );

      if (vehicleLookup.error) {
        let indexOfErrorCode = vehicleLookup.message.indexOf(
          " ",
          vehicleLookup.message.indexOf(":") + 1
        ); // get first : from the error string

        let statusCodeErrorMessage = vehicleLookup.message.substring(
          indexOfErrorCode + 1,
          indexOfErrorCode + 4
        );

        if (statusCodeErrorMessage == "404") {
          this.vehicleStatus = 2;
        } else {
          this.vehicleStatus = 3;
        }
      } else if (this.isMotStatusInvalid(vehicleLookup['result'].motStatus) || vehicleLookup['result'].taxStatus !== "Taxed") {
        if (this.isMotStatusInvalid(vehicleLookup['result'].motStatus)) {
          this.motStatusInvalid = true;
        }
        if (vehicleLookup['result'].taxStatus !== "Taxed") {
          this.taxStatusInvalid = true;
        }
      } else {
        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.makeQuestionId
        ].setValue(vehicleLookup["result"].make);
        this.bookingQuestionsForm.controls[
          this.dvlaLookupQuestionMap.makeQuestionId
        ].patchValue(vehicleLookup["result"].make);
        // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].disable()

        // this.bookingQuestionsForm.controls[
        //   this.dvlaLookupQuestionMap.colourQuestionId
        // ].setValue(vehicleLookup["result"].colour);
        // this.bookingQuestionsForm.controls[
        //   this.dvlaLookupQuestionMap.colourQuestionId
        // ].patchValue(vehicleLookup["result"].colour);
        // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].disable()

        this.vehicleStatus = 1;
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }
  }

  async repopulateQuestions() {
    console.log(" this.data.booking._embedded.answer", this.data.booking)
    const answers = await this.data.booking.getAnswers()
    console.log("answers", answers)
    for (let answer of answers) {
      if (this.bookingQuestionsForm.controls[answer.question_id]) {
        this.bookingQuestionsForm.controls[answer.question_id].setValue(
          answer.value
        );
      } else {
      }
    }
    console.log(this.bookingQuestionsForm.controls)
    this.populateStoredVehicleDetails();
    // this.getPostcode();
    this.vehicleStatus = 1;
    this.onQuestionChange();
    this.loading = false;
    this.spinner.hide();
  }

  onQuestionChange() {
    const bookingQuestions = this.bookingQuestions;
    // Conditional questions logic
    for (let index = 0; index < bookingQuestions.length; index++) {
      const q = bookingQuestions[index];
      // If the question has settings and relies on a conditional question
      if (q.settings && q.settings.hasOwnProperty("conditional_question")) {
        // Get the conditional question based on the id set in q
        const conditionalQ = bookingQuestions.filter(
          (question) => question.id == q.settings.conditional_question
        );
        // Get the question control
        const questionControl =
          this.bookingForm[q.settings.conditional_question];
        // If the question control has a value get the option from the contional question. This will allow
        // us to check if q is shown when value is selected
        const option = conditionalQ[0].options.filter(
          (option) => option.name == questionControl.value
        );
        // If the conditional question is visible and the value chosen === to qs conditional answer then show q
        if (
          conditionalQ.length > 0 &&
          conditionalQ[0].visible &&
          option.length > 0 &&
          q.settings.conditional_answers.hasOwnProperty(option[0].id)
        ) {
          this.bookingForm[q.id].enable();
          // If the condiditonal question is important, Hide it
          if (q.important) {
            q.visible = false;
          } else {
            q.visible = true;
          }
        } else {
          q.visible = false;
          this.bookingForm[q.id].setValue("");
          this.bookingForm[q.id].disable();
        }
      }
    }
  }

  continue() {
    // this.cancelMessage ? this.cancelMessage = false : this.cancelMessage = true;
    // this.cancelPromptMessage ? this.cancelPromptMessage = false : this.cancelPromptMessage = true;
  }

  cancelBooking(member, booking) {
    this.spinner.show();
    this.apiService
      .cancelBookings(booking, member)
      .then((res) => {
        this.emailService
          .sendEmail("CANCEL", booking, member.email, booking.company_id)
          .subscribe((res) => {
            console.log("here", booking);
            this.alertService.success(
              this.translateService.instant("ACCOUNT.CANCEL_SUCCESS")
            );
            this.spinner.hide();
            this.dialogRef.close(booking);
          });
      })
      .catch((error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.error(
          this.translateService.instant("ACCOUNT.CANCEL_FAILED")
        );
        this.spinner.hide();
        this.dialogRef.close();
      });
  }

  modifyBooking(member, booking) {
    this.alertService.clear();
    this.bookingService
      .cancelBooking(member, booking)
      .then((res) => {
        this.alertService.success(
          this.translateService.instant("ACCOUNT.CANCEL_SUCCESS")
        );
        this.dialogRef.close(booking);
      })
      .catch((error: HttpErrorResponse) => {
        this.dialogRef.close();
        this.alertService.error(
          this.translateService.instant("ACCOUNT.CANCEL_FAILED")
        );
        this.spinner.hide();
      });
  }

  selectedSlotCheck(slotUpdated: boolean) {
    if (slotUpdated) {
      this.availabilityService.getSelectedSlot().then((slot) => {
        if (slot) {
          this.slotEmpty = false;
          this.selectedSlot = slot.datetime;
          this.selectedSlotPersonId = slot;
        } else {
          this.slotEmpty = true;
        }
      });
    }
  }

  // Reschedule the booking
  confirmAmend(booking, slot, member) {
    const personId = this.selectedSlotPersonId.person_id;
    this.alertService.clear();
    const originalDateTime = booking.datetime;
    this.spinner.show();
    if (slot) {
      booking.datetime = moment(slot);
      this.slotEmpty = false;
      console.log(this.data.service);
      this.bookingService
        .rescheduleBooking(booking, member, slot)
        .then((booking) => {
          this.alertService.success(
            this.translateService.instant("ACCOUNT.MODIFY_SUCCESS")
          );
          this.spinner.hide();
          this.dialogRef.close();
        })
        .catch((error: HttpErrorResponse) => {
          booking.datetime = originalDateTime;
          this.dialogRef.close();
          this.spinner.hide();
          this.alertService.error(
            this.translateService.instant("ACCOUNT.MODIFY_FAILED")
          );
        });
    } else {
      this.slotEmpty = true;
      return;
    }
  }

  async saveBooking() {
    const booking = this.data.booking;
    this.spinner.show();
    console.log(booking);
    this.submitted = true;
    this.validationError = true;
    this.alertService.clear();

    console.log(this.bookingQuestionsForm.invalid);
    if (this.bookingQuestionsForm.invalid) {
      this.spinner.hide();
      // this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      this.validationError = true;
      return;
    } else {
      this.validationError = false;
    }

    const body = {
      questions: {},
    };
    // didn't use the dropdown so this needs set
    // console.log(
    //   "sda",
    //   this.bookingQuestionsForm.value[this.address_id].address
    // );
    // if (this.bookingQuestionsForm.value[this.address_id].address) {
    //   var custodian_codes = [
    //     2270, 2265, 2260, 2255, 2250, 2245, 2235, 2230, 2220, 2215, 2210, 2205,
    //   ]; //custodian_codes in kent
    //   const e = this.bookingQuestionsForm.value[this.address_id].address;
    //   const matchingCodes = custodian_codes.filter((code) => {
    //     if (e.LOCAL_CUSTODIAN_CODE === code) {
    //       return true;
    //     }
    //   });
    //   console.log("sda2", matchingCodes.length);

    //   if (!(matchingCodes.length > 0)) {
    //     body.questions[AppConfig.settings.out_of_county] = {
    //       answer: 1,
    //     };
    //   } else {
    //     body.questions[AppConfig.settings.out_of_county] = {
    //       answer: 0,
    //     };
    //   }
    //   this.bookingQuestionsForm.controls[this.address_id].setValue(
    //     this.bookingQuestionsForm.value[this.address_id].address.ADDRESS
    //   );
    // }
    for (var key in this.bookingQuestionsForm.value) {
      body.questions[key] = {
        answer: this.bookingQuestionsForm.value[key],
      };
      this.data.booking.answers.find((x) => x.question_id.toString() === key.toString()).value = this.bookingQuestionsForm.value[key]
      this.data.booking.questions.find((x) => x.question_id.toString() === key.toString()).value = this.bookingQuestionsForm.value[key]
    }
    const returnedBooking = await this.apiService.updateBooking(
      booking.id,
      booking.company_id,
      body
    );

    await this.memberService.getBookings()

    // this.data.booking = await this.apiService.getBooking(booking.id, booking.company_id)
    // this.initialiseBookingView();
    // this.showQuestions = false
    this.spinner.hide()
    console.log("answers", this.data.booking.answers)
    this.emailService
      .sendEmail("AMEND", booking, this.data.member.email, booking.company_id)
      .subscribe((res) => {
        this.alertService.success(
          this.translateService.instant("ACCOUNT.AMEND_SUCCESS")
        );
        this.dialogRef.close(this.data.booking);
      });

  }

  translateAnswer(answer) {
    if (answer === "true" || answer === true) {
      return "Yes";
    }
    if (answer === "false" || answer === false) {
      return "No";
    }
    return answer;
  }

  test(event: Event) {
    console.log("test");
    this.subscription.unsubscribe();
    this.spinner.hide();
  }

  async populateStoredVehicleDetails() {
    let vehiclereg: String =
      this.bookingQuestionsForm.value[this.dvlaLookupQuestionMap.regQuestionId];
    let vehicle = this.myVehicles.find(
      (x) => x.vehicle_registration === vehiclereg
    );
    if (vehicle) {
      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].setValue(vehicle.vehicle_make);
      this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.makeQuestionId].patchValue(vehicle.vehicle_make);

      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].setValue(vehicle.vehicle_colour);
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.colourQuestionId].patchValue(vehicle.vehicle_colour);
      // const question = this.bookingQuestions.find((x) => x.id === this.dvlaLookupQuestionMap.typeQuestionId)
      // const typeOption = question.options.find((x) => x.name.toLowerCase() === vehicle.vehicle_type.toLowerCase())
      // console.log(typeOption)
      // console.log(vehicle)
      // console.log(vehicle.vehicle_type)
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeQuestionId].setValue(typeOption.name);
      // this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeQuestionId].patchValue(typeOption.name);
      // if (vehicle.vehicle_type.toLowerCase() === 'other') {
      //   console.log(this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId])
      //   if (this.bookingQuestions.find((x) => x.id === this.dvlaLookupQuestionMap.typeOtherQuestionId).visible === false) {
      //     this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId].enable()
      //     this.bookingQuestions.find((x) => x.id === this.dvlaLookupQuestionMap.typeOtherQuestionId).visible = true
      //   }
      //   this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId].setValue(vehicle.other_vehicle);
      //   this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId].patchValue(vehicle.other_vehicle);
      // } else {
      //   this.bookingQuestionsForm.controls[this.dvlaLookupQuestionMap.typeOtherQuestionId].disable()
      //   this.bookingQuestions.find((x) => x.id === this.dvlaLookupQuestionMap.typeOtherQuestionId).visible = false
      // }
      this.onQuestionChange()
    } else {
      // won't be using the dropdown list as booking was made as a guest
      this.manualText = true;
      this.myVehicles = [];
      this.myAddresses = [];
    }
    this.vehicleStatus = 1;
  }

  async getAddress(repopulate: boolean = null) {
    this.showingAddresses = false;

    // Clear the addresses array
    this.addresses.length = 0;
    console.log(this.bookingQuestionsForm.controls);
    if (!repopulate) {
      this.bookingQuestionsForm.controls[this.address_id].setValue("");
    }
    // Custom error handling for postcode
    let postcode: String = this.bookingQuestionsForm.value[
      this.postcode_id
    ].replace(/\s/g, "");
    this.bookingQuestionsForm.controls[this.postcode_id].setValue(postcode);
    if (
      this.bookingQuestionsForm.controls[this.postcode_id].status == "INVALID"
    ) {
      this.bookingQuestionsForm
        .get(this.postcode_id)
        .setErrors({
          invalidPostcode: this.translateService.instant(
            "COMMON.INVALID_POSTCODE"
          ),
        });
      return;
    }
    this.spinner.show();
    const res = await this.apiService.get(
      this.bookingQuestionsForm.value[this.postcode_id]
    );
    if (
      this.bookingQuestionsForm.controls[this.postcode_id].errors &&
      this.bookingQuestionsForm.controls[this.postcode_id].errors
        .invalidPostcode
    ) {
      delete this.bookingQuestionsForm.controls[this.postcode_id].errors
        .invalidPostcode;
    }
    var object: any = res;
    if (object.results) {
      if (
        this.bookingQuestionsForm.controls[this.postcode_id].errors &&
        this.bookingQuestionsForm.controls[this.postcode_id].errors
          .addressNotFound
      ) {
        delete this.bookingQuestionsForm.controls[this.postcode_id].errors
          .addressNotFound;
      }
      var addresses = object.results;
      // Check if the custodian code that the user has entered matches the solihul custodian code
      // const custodian_codes = [7655, 4625,3720];
      // If no DPA exists, use LPI
      const addressesExist = addresses.filter((e) => {
        if (e.DPA) {
          return true;
        } else if (e.LPI) {
          return true;
        }
      });

      const addressException = await this.apiService.getAddressException();
      let expections = [];

      if (addressException) {
        expections = addressException["Items"];
      }

      let added = [];

      if (addressesExist.length > 1) {
        // If it matches up, push the addresses
        addressesExist.forEach((item) => {
          const expectionAddress = expections.find(({ UPRN }) => {
            if (item.DPA) {
              if (UPRN === item.DPA.UPRN) {
                return true;
              }
            }
            if (item.LPI) {
              if (UPRN === item.LPI.UPRN) {
                return true;
              }
            }

            return false;
          });

          const addedAlready = added.find(({ ADDRESS }) => {
            if (item.DPA) {
              if (ADDRESS === item.DPA.ADDRESS) {
                return true;
              }
            }
            if (item.LPI) {
              if (ADDRESS === item.LPI.ADDRESS) {
                return true;
              }
            }

            return false;
          });

          let alreadyEntered = false;

          if (expectionAddress === undefined) {
            alreadyEntered = this.addresses.some((e) => {
              if (item.DPA && item.DPA.UPRN === e.address.UPRN) {
                return true;
              } else if (item.LPI && item.LPI.UPRN === e.address.UPRN) {
                return true;
              }
            });
          }

          if (!alreadyEntered && addedAlready === undefined) {
            if (item.DPA) {
              this.addresses.push({ address: item.DPA });
              added.push({ ADDRESS: item.DPA.ADDRESS });
            } else {
              this.addresses.push({ address: item.LPI });
              added.push({ ADDRESS: item.LPI.ADDRESS });
            }
          }
        });

        if (repopulate) {
          console.log(this.bookingQuestionsForm.value[this.address_id]);
          let selectedAddress =
            this.bookingQuestionsForm.value[this.address_id];
          for (let i = 0; i < this.addresses.length; i++) {
            let item = this.addresses[i];
            if (selectedAddress == item.address.ADDRESS) {
              this.selectedAddressId = i;
              this.bookingQuestionsForm.controls[this.address_id].setValue(
                item
              );
            }
          }
        }
        this.showingAddresses = true;
      } else {
        // If it doesn't match up, show an error message
        this.bookingQuestionsForm
          .get(this.postcode_id)
          .setErrors({
            invalidPostcode: this.translateService.instant(
              "COMMON.ADDRESS_NOT_ELIGIBLE"
            ),
          });
      }
    } else {
      this.bookingQuestionsForm
        .get(this.postcode_id)
        .setErrors({
          addressNotFound: this.translateService.instant(
            "COMMON.ADDRESS_NOT_FOUND"
          ),
        });
    }
    this.spinner.hide();
  }

  // Number input text validation, keycode 8 is backspace
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  localAddress() {
    return this.formService.localAddress(
      this.bookingQuestionsForm.value[this.address_id].address
    );
  }
}
